import moment from "moment";
export const showDate = (date) => {
  return moment(date).format("LL");
};

export const toISOStringFromat = (date) => {
  if (!date) return "";
  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) return "";

  // Extract components in local time to avoid timezone shift
  let year = parsedDate.getFullYear();
  
  // Handle cases where the user types a 6-digit year or larger by slicing it to 4 digits
  if (year > 9999) {
    year = String(year).slice(0, 4);
  } else {
    year = String(year).padStart(4, "0");
  }

  const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
  const day = String(parsedDate.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const MMDDYYFormat = (date) => {
  // console.log("date",date)
   if (!date) return "mm/dd/yy";

  const parsed = new Date(date);
  if (isNaN(parsed.getTime())) return "";

  // Extract the date from the UTC components so there's no local timezone shift
  const month = String(parsed.getUTCMonth() + 1).padStart(2, "0");
  const day = String(parsed.getUTCDate()).padStart(2, "0");
  const year = String(parsed.getUTCFullYear()).slice(-2);
//  console.log(" `${month}/${day}/${year}`", `${month}/${day}/${year}`)
  return `${month}/${day}/${year}`;
};

export const toISOStringFromat1 = (date) => {
  // if (date) {
  //   const localDate = new Date(date);
  //   localDate.setMinutes(
  //     localDate.getMinutes() - localDate.getTimezoneOffset()
  //   );
  //   return (
  //     ("0" + (localDate.getMonth() + 1)).slice(-2) +
  //     "/" +
  //     ("0" + localDate.getDate()).slice(-2) +
  //     "/" +
  //     localDate.getFullYear().toString().slice(-2)
  //   );
  // }
  // return "mm/dd/yy";
  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) return ""; // Handle invalid dates

  // Format the date using US locale and options
  return parsedDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};
// export const toISOStringFromat1 = (date) => {
//   if (date) {
//     const localDate = new Date(date);
//     const gmt8Offset = 8 * 60;

//     // Adjust the date for GMT-8
//     const offsetDifference = localDate.getTimezoneOffset() + gmt8Offset;
//     localDate.setMinutes(localDate.getMinutes() - offsetDifference);

//     return (
//       ("0" + (localDate.getMonth() + 1)).slice(-2) +
//       "/" +
//       ("0" + localDate.getDate()).slice(-2) +
//       "/" +
//       localDate.getFullYear().toString().slice(-2)
//     );
//   }
//   return "mm/dd/yy";
// };
